import angleRight from "../../../assets/svg/angle-right.svg";
const plusIcon = true; // Set to false to use angle right icon
const titleIcon = plusIcon ? "" : angleRight;
const titleIconClass = plusIcon ? "panels__plus-icon" : "";

export class Panel {
	constructor(node) {
		this.node = node;
		this.openedClass = "panels__panel--opened";
		this.opened = this.node.classList.contains(this.openedClass);
		this.title = this.node.querySelector(".panels__title");
		this.content = this.node.querySelector(".panels__content");
		this.node.classList.remove(this.openedClass);
		// Have the panel open on page refresh
		this.opened = false;
		if (this.title) this.title.setAttribute("aria-expanded", "false");
		if (this.title) {
			this.title.insertAdjacentHTML(
				"beforeend",
				`<span class="panels__toggle ${titleIconClass}">${titleIcon}</span>`
			);
			this.title.addEventListener("click", () => this.toggle());
		}

		this.node.dataset.panelsInit = 1;
	}

	open() {
		this.node.classList.add(this.openedClass);
		this.title.setAttribute("aria-expanded", "true");

		this.content.style.display = "block";
		this.content.style.position = "absolute";

		let height = this.content.offsetHeight;

		this.content.style.position = "";
		this.content.style.height = "0px";
		this.content.style.overflow = "hidden";

		let transitionend = (e) => {
			this.content.removeAttribute("style");
			this.opened = true;
			this.content.removeEventListener("transitionend", transitionend);
		};

		this.content.addEventListener("transitionend", transitionend);

		this.content.style.transitionProperty = "height, opacity";
		this.content.style.transitionDuration = "300ms";
		this.content.style.transitionTimingFunction =
			"cubic-bezier(0.68, -0.55, 0.265, 1.55), linear";

		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				this.content.style.height = `${height}px`;
				this.content.style.opacity = 1;
			});
		});
	}

	close() {
		this.node.classList.remove(this.openedClass);
		this.title.setAttribute("aria-expanded", "false");
		this.content.style.display = "block";
		this.content.style.overflow = "hidden";
		this.content.style.height = `${this.content.offsetHeight}px`;
		this.content.style.transitionProperty = "height, opacity";
		this.content.style.transitionDuration = "300ms";
		this.content.style.transitionTimingFunction =
			"cubic-bezier(0.68, -0.55, 0.265, 1.55), linear";

		let transitionend = (e) => {
			this.content.removeAttribute("style");
			this.opened = false;
			this.content.removeEventListener("transitionend", transitionend);
		};

		this.content.addEventListener("transitionend", transitionend);

		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				this.content.style.height = "0";
				this.content.style.opacity = 0;
			});
		});
	}

	toggle() {
		return this.opened ? this.close() : this.open();
	}
}

export class Panels {
	constructor(node) {
		this.node = node;
		this.node.classList.add("panels--interactive");
		this.panels = Array.from(this.node.querySelectorAll(".panels__panel")).map(
			(node) => new Panel(node)
		);
	}
}
